import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "breadcrumb mt-[12px] md:mt-0" }
const _hoisted_3 = {
  key: 0,
  class: "breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0"
}
const _hoisted_4 = {
  key: 1,
  class: "breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_MyProfile = _resolveComponent("MyProfile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (this.$route.query.is_from_reports === '1')
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, _cache[0] || (_cache[0] = [
            _createElementVNode("a", {
              style: {"text-underline":"none"},
              href: "/reports/manage",
              class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500"
            }, " Отчет ", -1)
          ])))
        : (_openBlock(), _createElementBlock("li", _hoisted_4, _cache[1] || (_cache[1] = [
            _createElementVNode("a", {
              style: {"text-underline":"none"},
              href: "/tasks/manage",
              class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500"
            }, " Задачи ", -1)
          ]))),
      _cache[2] || (_cache[2] = _createElementVNode("li", { class: "breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0" }, " Мой профиль ", -1))
    ]),
    _createVNode(_component_PageTitle, {
      pageTitle: "Мой профиль",
      subTitle: "Мой профиль"
    }),
    _createVNode(_component_MyProfile)
  ]))
}